enum SUPPORTED_BRANDS {
  ATP = 'atp',
  SWA = 'swa',
  UNIFIED = 'unified',
}

export default SUPPORTED_BRANDS;
